import { useDownloadDiplomaMutation, useEmailDiplomaMutation } from '../diplomaApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_INFO } from '../../../utils/constants';
import i18next from 'i18next';

export const useDiplomaActions = () => {
  const [downloadDiplomaTrigger] = useDownloadDiplomaMutation();
  const [emailDiplomaTrigger] = useEmailDiplomaMutation();

  const downloadDiploma = async ({ courseId }) => {
    try {
      enqueueSnackbar(i18next.t('diploma.preparingDownload'), { variant: TOAST_INFO });
      const result = await downloadDiplomaTrigger({ courseId }).unwrap();
      return result;
    } catch (err) {
      const errorMessage = err?.data?.errMsg || i18next.t('diploma.downloadFailed');
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const emailDiploma = async ({ courseId, recipientEmail }) => {
    try {
      const result = await emailDiplomaTrigger({ courseId, recipientEmail }).unwrap();
      enqueueSnackbar(i18next.t('diploma.emailSent'), { variant: TOAST_INFO });
      return result;
    } catch (err) {
      const errorMessage = err?.data?.response?.errMsg || i18next.t('diploma.emailFailed');
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    downloadDiploma,
    emailDiploma,
  };
};
